import { useState } from 'react';
import { useFidelityTokenId } from './hooks/useFidelityTokenId';
import { AuthenticationAuthorityDTO, EntityDTO } from './DocumentVault.meta';

export interface Entity extends EntityDTO {
  forceUserAuthentication?: boolean;
}

export const useDocumentVault = () => {
  const [selectedEntity, setEntity] = useState<Entity | null>(null);

  const [forceYear, setForceYear] = useState<number | null>(null);

  const { getCurrentTokenId } = useFidelityTokenId();

  const currentTokenId = getCurrentTokenId();

  const setSelectedEntity = (entity: Entity | null) => {
    setEntity(entity);

    if (entity?.authenticationAuthority === AuthenticationAuthorityDTO.FidelityDocuments) {
      return !!currentTokenId;
    }

    return true;
  };

  return {
    data: {
      selectedEntity,
      forceYear,
    },
    actions: {
      setSelectedEntity,
      setForceYear,
    },
  };
};
